module.exports = __webpack_public_path__ + "0685d7bb3d2fddc57ae3c1d07e25037b.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/content/fonts/ArialMT-Bold.ttf
// module id = 358
// module chunks = 1